import * as Yup from "yup";
export const appStatusSchema = Yup.object().shape({
  mobileNumber: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be 10 digits")
    .nullable(),
  applicationId: Yup.string()
    .matches(/^[A-Za-z0-9]+$/, "Application ID must be alphanumeric")
    .nullable(),
}).test(
  "one-of-two-required",
  "Either Mobile Number or Application ID is required",
  function (values) {
    return !!values.mobileNumber || !!values.applicationId;
  }
);
  